export default class Vacations {
  constructor(action, start, end, comments) {
    this.action = action;
    this.start = start;
    this.end = end;
    this.comments = comments;

  }
}
